import script from "./NewRequestButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRequestButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__